import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=36a47c78"
import script from "./Matching.vue?vue&type=script&lang=js"
export * from "./Matching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports